import { debug } from '@skinsoft/debug';
import { merge, of, Subject } from 'rxjs';
import { distinctUntilChanged, filter, map, tap, throttleTime } from 'rxjs/operators';

import { Cache } from '@skinsoft/types';

export class MemoryCache<T> implements Cache<T> {
    private static debug = debug('memory-cache');

    private storage = new Map<string, T[]>();
    private tick$ = new Subject<string>();

    public notifyOn(pattern: RegExp) {
        return this.tick$.pipe(
            filter(uri => pattern.test(uri)),
            throttleTime(100),
            distinctUntilChanged(),
        );
    }

    public read(uri: string) {
        return merge(of(null), this.tick$.pipe(filter(value => value === uri))).pipe(
            map(() => this.storage.get(uri)),
            tap(value => {
                MemoryCache.debug('read', uri, value);
            }),
        );
    }

    public remove(uri: string) {
        MemoryCache.debug('remove', uri, this.storage.get(uri));
        this.storage.delete(uri);
        this.tick(uri);
    }

    public write(uri: string, data: T[]) {
        MemoryCache.debug('write', uri, this.storage.get(uri));
        this.storage.set(uri, data);
        this.tick(uri);
    }

    private tick(uri: string) {
        this.tick$.next(uri);
    }
}
